import { render, staticRenderFns } from "./ErrorDelete.vue?vue&type=template&id=40252e23&"
import script from "./ErrorDelete.vue?vue&type=script&lang=js&"
export * from "./ErrorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports